import React from "react";
import { BaseWalletMultiButton } from "@solana/wallet-adapter-react-ui";
import type {
  CSSProperties,
  MouseEvent,
  PropsWithChildren,
  ReactElement,
} from "react";

const LABELS = {
  "change-wallet": "Change wallet",
  connecting: "Connecting ...",
  "copy-address": "Copy address",
  copied: "Copied",
  disconnect: "Disconnect",
  "has-wallet": "Connect",
  "no-wallet": "Connect Wallet",
} as const;

export function ConnectWalletButton(props: ButtonProps) {
  return (
    <BaseWalletMultiButton
      {...props}
      labels={LABELS}
      style={{
        backgroundColor: '#06b6d4',  
        color: 'white',
        fontWeight: '500',
        borderRadius: '0.375rem', 
        padding: '0.5rem 1rem', 
        // transition: 'none',
        height: '44px'
      }}
    />
  );
}

export type ButtonProps = PropsWithChildren<{
  className?: string;
  disabled?: boolean;
  endIcon?: ReactElement;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  startIcon?: ReactElement;
  style?: CSSProperties;
  tabIndex?: number;
}>;

